import React, { useState, useEffect } from "react";

export default function ImbaChat(props) {
  function openChat() {
    if (!window.imbaApi) {
      setTimeout(() => {
        openChat();
      }, 5000);
      return;
    }
    window.imbaSupport = new window.ImbaSupport();
    window.imbaSupport.init({
      user_id: props.user_id,
      token: props.user_token,
      user_role: "admin",
      api_url: "https://api.imbachat.com/imbasupport/v1/" + props.imba_id + "/",

      imba_id: props.imba_id,
    });
    /*window.imbaSupport.openUnAssignedDialogs();*/
    if (window.imbaApi) {
      window.imbaApi.load({
        user_id: props.user_id,
        token: props.user_token,
      });
    }
  }

  useEffect(() => {
    setTimeout(() => {
      openChat();
    }, 5000);
  }, []);

  return <div></div>;
}
